<p-panel [header]="'Additional_Parameters_Title' | translateWF: 'Additional Parameters'">
  <ng-template pTemplate="icons">
    @if (canEdit()) {
      <p-button [label]="'Additional_Parameters_Add' | translateWF: 'Add Parameter'" icon="pi pi-plus" variant="outlined" (click)="addParameter()" />
    }
  </ng-template>
  <p-card data-variant="compact">
    <form [formGroup]="formGroup">
      <p-table [value]="additionalParameters.controls" formArrayName="additionalParameters" cdkDropList (cdkDropListDropped)="canEdit() ? drop($event) : null">
        <ng-template pTemplate="header">
          <tr>
            @if (canEdit()) {
              <th></th>
            }
            <th>{{ 'Additional_Parameters_Active' | translateWF: 'Active' }}</th>
            <th>
              {{ 'Additional_Parameters_Type' | translateWF: 'Parameter Type' }}
            </th>
            <th>
              {{ 'Additional_Parameters_Multiple' | translateWF: 'Multiple Values' }}
            </th>
            <th>
              {{ 'Additional_Parameters_Required' | translateWF: 'Required' }}
            </th>
            <th>
              {{ 'Additional_Parameters_Default' | translateWF: 'Default Values' }}
            </th>
            @if (canEdit()) {
              <th>{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-param let-i="rowIndex">
          <tr [formGroupName]="i" cdkDrag [cdkDragDisabled]="!canEdit()" [cdkDragData]="param">
            @if (canEdit()) {
              <td>
                <span class="material-icons draggable">menu</span>
              </td>
            }
            <td>
              <p-checkbox formControlName="isActive" [binary]="true" [readonly]="!canEdit()" [styleClass]="!canEdit() ? 'p-disabled' : ''" />
            </td>
            <td>
              <p-select
                appendTo="body"
                class="w-full"
                [options]="allParameters()"
                optionLabel="name.en"
                optionValue="id"
                formControlName="parameterRef"
                [readonly]="!canEdit()"
                [styleClass]="!canEdit() ? 'p-disabled' : ''"
              />
            </td>
            <td>
              <p-checkbox
                formControlName="hasMultipleValues"
                [binary]="true"
                (onChange)="canEdit() ? resetParamValues(i) : null"
                [readonly]="!canEdit()"
                [styleClass]="!canEdit() ? 'p-disabled' : ''"
              />
            </td>
            <td>
              <p-checkbox formControlName="isRequired" [binary]="true" [readonly]="!canEdit()" [styleClass]="!canEdit() ? 'p-disabled' : ''" />
            </td>
            <td>
              @if (!param.controls.hasMultipleValues.value) {
                @if (param && param.controls && param.controls.values && param.controls.values.controls[0]) {
                  <div>
                    <input type="text" [formControl]="param.controls.values.controls[0]" pInputText [readonly]="!canEdit()" [class.p-disabled]="!canEdit()" />
                    @if (param.controls.values.controls[0].errors && canEdit()) {
                      <p class="error">
                        {{ getParameterTypeErrorMessage(param.controls.values.controls[0]) }}
                      </p>
                    }
                  </div>
                }
              } @else {
                @if (canEdit()) {
                  <div class="row-sm-start-center">
                    <!-- <span class="text-sm text-gray-600">
                      {{ param.controls.values.length }}
                      {{ param.controls.values.length === 1 ? 'value' : 'values' }}
                    </span> -->
                    <p-button
                      [label]="'Additional_Parameters_Values' | translateWF: 'Values'"
                      icon="pi pi-pencil"
                      variant="outlined"
                      size="small"
                      (click)="openStepValuesModal(i)"
                    />
                  </div>
                } @else {
                  @if (param.controls.values.length > 0) {
                    <input type="text" pInputText [value]="getValuesAsSemicolonSeparated(param.controls.values)" readonly class="p-disabled" />
                  } @else {
                    <span class="text-gray-400 italic text-sm">No values</span>
                  }
                }
              }
            </td>
            @if (canEdit()) {
              <td>
                <p-button icon="pi pi-trash" (click)="removeParameter(i)" />
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </form>
  </p-card>
</p-panel>
